import React, {forwardRef, SyntheticEvent, useState} from "react"
import TimeReport from "../../../../../../../model2/time-report/time-report"
import FieldProto from "../../../../../../proto/field-proto";
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../../gd-components/buttons/control-button/control-button-standard";

type Props = {
    className?  : string

    field       : FieldProto
    timeReport  : TimeReport

    onClick     : func

    children?   : any
}

const FieldTimeReported_InlineValue = forwardRef<HTMLDivElement, Props>((props, ref) => {

    const [isHovered, setIsHovered] = useState(false)

    const onAddTimeReport = (e: SyntheticEvent) => {
        e.stopPropagation()

        const options = {
            date    : moment(props.timeReport.date?.format("YYYY-MM-DD")), // Moment!! not MomentDate
            userId  : props.timeReport.userId
        }

        if (props.timeReport.meeting) {
            gd.modals.myTime.timeReportForMeeting(props.timeReport.meeting, options)
            return
        }

        gd.modals.myTime.timeReportForTask(props.timeReport.task, options)
    }

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const minutes       = props.timeReport?.reportedTimeMinutes || props.timeReport?.estimatedTimeMinutes
    const isGuesstimate = props.timeReport.isGuesstimate

    const valueFormatted = minutes ? props.field.getDisplayValue(minutes) : "Log time"

    const className = Classes("ui5-field-editable size-small min-w-110", props.className, {
        'is-empty'                  : !minutes,
        'is-hovered'                : isHovered || props.children,
        'ui5-txt-default'           : minutes,
        'ui5-txt-no-accent-small'   : !minutes || isGuesstimate
    })

    return (
        <React.Fragment>
            <div ref            = {ref}
                 className      = {className}
                 onMouseEnter   = {onMouseEnter}
                 onMouseLeave   = {onMouseLeave}
                 onClick        = {props.onClick}
            >
                <div className="flex-row-center-between w-100p">
                    <div className="flex-row-left-center">

                        {isGuesstimate && <span>~</span>}

                        {valueFormatted}
                    </div>

                    {isHovered && minutes && !isGuesstimate && (
                        <ControlButtonStandard
                            className   = "btn-add"
                            type        = {ControlButtonType.PLUS}
                            size        = {24}
                            hint        = "Add time report"
                            onClick     = {onAddTimeReport}
                        />
                    )}
                </div>
            </div>
            {props.children}
        </React.Fragment>
    )
})

export default FieldTimeReported_InlineValue
